import { mergeMap, filter } from 'rxjs/operators'
import { afterAllTypes } from '../../../lib/observables'
import { SET_ROOMNAME, SET_USER } from '../../constants/actionTypes'
import dialInActions from '../../actions/dialIn/dialInActions'
import structuredSelectPresenter from '../../selectors/structuredSelectPresenter'

const dialIn$ = (actions$, state$) => actions$.pipe(
  afterAllTypes(SET_USER, SET_ROOMNAME),
  filter(() =>
      state$.value.config.featureFlags.dialIn &&
      state$.value.config.bridgeName === ''
  ),
  mergeMap(() => [
    dialInActions.fetchDialInCode(state$.value.config.roomname, structuredSelectPresenter(state$.value, { BTID: state$.value.user.BTID || ''})), 
    dialInActions.fetchDialInPhoneNumbers(state$.value.config.roomname)])
)

export default dialIn$
